import { z } from 'zod';

// Query for the per-supplier worked-hours + headcount report (invoice
// reconciliation). `from`/`to` are inclusive YYYY-MM-DD date strings; supplierId
// narrows to a single agency; worksiteId narrows to one site; groupBy slices the
// breakdown by calendar day or by worksite/site. `format=excel` switches the
// JSON response for a self-describing .xlsx workbook (parity with other reports).
export const SupplierReportQuerySchema = z.object({
  from: z.string().date().optional(),
  to: z.string().date().optional(),
  supplierId: z.string().optional(),
  worksiteId: z.string().optional(),
  groupBy: z.enum(['day', 'site']).optional(),
  format: z.enum(['excel', 'pdf']).optional(),
});
export type SupplierReportQuery = z.infer<typeof SupplierReportQuerySchema>;
